import { Action } from 'redux'
import { File } from '../../lib/interfaces/File.interface'
import { EmployeeUpdateRequest } from '../../lib/api/employees'
import { EmployeeComment } from '../../lib/interfaces/EmployeeComment.interface'
import { Employee, EmployeeFilterParams } from '../../lib/interfaces/Employee.interface'

export const actionTypes = {
  EMPLOYEES_FETCH_LIST: 'EMPLOYEES_FETCH_LIST',
  EMPLOYEES_FETCH_LIST_FAILED: 'EMPLOYEES_FETCH_LIST_FAILED',
  EMPLOYEES_FETCH_LIST_SUCCESS: 'EMPLOYEES_FETCH_LIST_SUCCESS',

  EMPLOYEES_SET_CURRENT: 'EMPLOYEES_SET_CURRENT',
  EMPLOYEES_SET_CURRENT_SUCCESS: 'EMPLOYEES_SET_CURRENT_SUCCESS',
  EMPLOYEES_SET_CURRENT_FAILED: 'EMPLOYEES_SET_CURRENT_FAILED',

  EMPLOYEE_FETCH: 'EMPLOYEE_FETCH',
  EMPLOYEE_FETCH_FAILED: 'EMPLOYEE_FETCH_FAILED',
  EMPLOYEE_FETCH_SUCCESS: 'EMPLOYEE_FETCH_SUCCESS',

  EMPLOYEE_FETCH_FILES: 'EMPLOYEE_FETCH_FILES',
  EMPLOYEE_FETCH_FILES_FAILED: 'EMPLOYEE_FETCH_FILES_FAILED',
  EMPLOYEE_FETCH_FILES_SUCCESS: 'EMPLOYEE_FETCH_FILES_SUCCESS',

  EMPLOYEE_UPLOAD_FILE: 'EMPLOYEE_UPLOAD_FILE',
  EMPLOYEE_UPLOAD_FILE_FAILED: 'EMPLOYEE_UPLOAD_FILE_FAILED',
  EMPLOYEE_UPLOAD_FILE_SUCCESS: 'EMPLOYEE_UPLOAD_FILE_SUCCESS',

  EMPLOYEE_POST_COMMENT: 'EMPLOYEE_POST_COMMENT',
  EMPLOYEE_POST_COMMENT_FAILED: 'EMPLOYEE_POST_COMMENT_FAILED',
  EMPLOYEE_POST_COMMENT_SUCCESS: 'EMPLOYEE_POST_COMMENT_SUCCESS',

  EMPLOYEE_FETCH_COMMENTS: 'EMPLOYEE_FETCH_COMMENTS',
  EMPLOYEE_FETCH_COMMENTS_FAILED: 'EMPLOYEE_FETCH_COMMENTS_FAILED',
  EMPLOYEE_FETCH_COMMENTS_SUCCESS: 'EMPLOYEE_FETCH_COMMENTS_SUCCESS',

  EMPLOYEE_UPDATE: 'EMPLOYEE_UPDATE',
  EMPLOYEE_UPDATE_FAILED: 'EMPLOYEE_UPDATE_FAILED',
  EMPLOYEE_UPDATE_SUCCESS: 'EMPLOYEE_UPDATE_SUCCESS'
}

/**
 * Fetch Employees
 */

export interface EmployeesFetchAction extends Action {
  payload: {
    next?: () => void,
    filterParams?: EmployeeFilterParams
  }
}

export const fetchEmployees = (filterParams: EmployeeFilterParams, next?: () => void): EmployeesFetchAction => ({
  type: actionTypes.EMPLOYEES_FETCH_LIST,
  payload: { next, filterParams },
})


/**
 * Fetch Employees Success
 */

export interface EmployeesFetchSuccessAction extends Action {
  payload: {
    employees: Employee[],
  }
}

export const fetchEmployeesSuccess = (employees: Employee[]): EmployeesFetchSuccessAction => ({
  type: actionTypes.EMPLOYEES_FETCH_LIST_SUCCESS,
  payload: { employees },
})

/**
 * Fetch Employees Error
 */
export interface EmployeesFetchErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchEmployeesError = (errorMessage?: string): EmployeesFetchErrorAction => ({
  type: actionTypes.EMPLOYEES_FETCH_LIST_FAILED,
  payload: { errorMessage },
})

/**
 * Set Current Employee
 */
export interface EmployeesSetCurrentAction extends Action {
  payload: {
    employee?: Employee,
  }
}

export const setCurrentEmployee = (employee?: Employee): EmployeesSetCurrentAction => ({
  type: actionTypes.EMPLOYEES_SET_CURRENT,
  payload: { employee },
})

// success
export interface EmployeesSetCurrentSuccessAction extends Action {
  payload: {
    employee: Employee
  }
}

export const setCurrentEmployeeSuccess = (employee: Employee):EmployeesSetCurrentSuccessAction => ({
  type: actionTypes.EMPLOYEES_SET_CURRENT_SUCCESS,
  payload: { employee }
})

// error
export interface EmployeesSetCurrentErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const setCurrentEmployeeError = (errorMessage?: string): EmployeesSetCurrentErrorAction => ({
  type: actionTypes.EMPLOYEES_SET_CURRENT_FAILED,
  payload: { errorMessage }
})

/**
* Fetch employee
*/
export interface EmployeeFetchAction extends Action {
  payload: {
    employeeId: string,
    next?: (err?: any, employee?: Employee) => void
  }
}

export const fetchEmployee = (employeeId: string, next?: () => void): EmployeeFetchAction => ({
  type: actionTypes.EMPLOYEE_FETCH,
  payload: { next, employeeId },
})


/**
 * Fetch employee success
 */
export interface EmployeeFetchSuccessAction extends Action {
  payload: {
    employee: Employee,
  }
}

export const fetchEmployeeSuccess = (employee: Employee): EmployeeFetchSuccessAction => ({
  type: actionTypes.EMPLOYEE_FETCH_SUCCESS,
  payload: { employee }
})

/**
  * Fetch employee error
  */
export interface EmployeeFetchErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchEmployeeError = (errorMessage?: string): EmployeeFetchErrorAction => ({
  type: actionTypes.EMPLOYEE_FETCH_FAILED,
  payload: { errorMessage },
})

/**
 * Fetch employee files
 */
export interface EmployeeFetchFilesAction extends Action {
 payload: {
   employeeId: string
 }
}

export const fetchEmployeeFiles = (employeeId: string): EmployeeFetchFilesAction => ({
 type: actionTypes.EMPLOYEE_FETCH_FILES,
 payload: { employeeId }
})

 /**
  * Fetch employee files success
  */
export interface EmployeeFetchFilesSuccessAction extends Action {
  payload: {
    files: File[]
    employeeId: string,
  }
}

export const fetchEmployeeFilesSuccess = (files: File[], employeeId: string): EmployeeFetchFilesSuccessAction => ({
  type: actionTypes.EMPLOYEE_FETCH_FILES_SUCCESS,
  payload: { files, employeeId }
})

/**
 * Fetch employee files error
 */
export interface EmployeeFetchFilesErrorAction extends Action {
 payload: {
   errorMessage?: string
 }
}

export const fetchEmployeeFilesFailed = (errorMessage?: string): EmployeeFetchFilesErrorAction => ({
  type: actionTypes.EMPLOYEE_FETCH_FILES_FAILED,
  payload: { errorMessage }
})

/*
 * Upload employee file
 */
export interface EmployeeUploadFileAction extends Action {
  payload: {
    file: any
    employeeId: string
    confidential: boolean
  }
 }
 
 export const uploadEmployeeFile = (employeeId: string, file: any, confidential: boolean = false): EmployeeUploadFileAction => ({
  type: actionTypes.EMPLOYEE_UPLOAD_FILE,
  payload: { file, employeeId, confidential }
 })
 
 // Success
 export const uploadEmployeeFileSuccess = (): Action => ({
  type: actionTypes.EMPLOYEE_UPLOAD_FILE_SUCCESS
 })
 
 // Error
 export interface EmployeeUploadFileErrorAction extends Action {
   payload: {
     errorMessage: string
   }
 }
 
 export const uploadEmployeeFileError = (errorMessage: string): EmployeeUploadFileErrorAction => ({
   type: actionTypes.EMPLOYEE_UPLOAD_FILE_FAILED,
   payload: { errorMessage }
 })

/**
 * Post employee comment
 */
export interface EmployeePostCommentAction extends Action {
  payload: {
    comment: string,
    employeeId: string
  }
}

export const postEmployeeComment = (employeeId: string, comment: string): EmployeePostCommentAction => ({
  type: actionTypes.EMPLOYEE_POST_COMMENT,
  payload: { comment, employeeId }
})

// Success
export interface EmployeePostCommentSuccessAction extends Action {
  payload: {
    employeeId: string
    comment: EmployeeComment
  }
}

export const postEmployeeCommentSuccess = (employeeId: string, comment: EmployeeComment): EmployeePostCommentSuccessAction => ({
  type: actionTypes.EMPLOYEE_POST_COMMENT_SUCCESS,
  payload: { comment, employeeId }
})

// Error
export interface EmployeePostCommentErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const postEmployeeCommentError = (errorMessage?: string): EmployeePostCommentErrorAction => ({
  type: actionTypes.EMPLOYEE_POST_COMMENT_FAILED,
  payload: { errorMessage }
})

/**
 * Fetch employee comments
 */
export interface EmployeeFetchCommentsAction extends Action {
  payload: {
    employeeId: string
  }
}

export const fetchEmployeeComments = (employeeId: string): EmployeeFetchCommentsAction => ({
  type: actionTypes.EMPLOYEE_FETCH_COMMENTS,
  payload: { employeeId }
})

// Success
export interface EmployeeFetchCommentsSuccessAction extends Action {
  payload: {
    employeeId: string
    comments: EmployeeComment[]
  }
}

export const fetchEmployeeCommentsSuccess = (employeeId: string, comments: EmployeeComment[]): EmployeeFetchCommentsSuccessAction => ({
  type: actionTypes.EMPLOYEE_FETCH_COMMENTS_SUCCESS,
  payload: { comments, employeeId }
})

// Error
export interface EmployeeFetchCommentsErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchEmployeeCommentsError = (errorMessage?: string): EmployeeFetchCommentsErrorAction => ({
  type: actionTypes.EMPLOYEE_FETCH_COMMENTS_FAILED,
  payload: { errorMessage }
})

/**
 * Update employee
 */
export interface EmployeeUpdateAction extends Action {
  payload: {
    employeeId: string
    employee: EmployeeUpdateRequest
    next?: (err?: any, employee?: Employee) => void
  }
}

export const updateEmployee = (employeeId: string, employee: EmployeeUpdateRequest, next?: (err?: any, employee?: Employee) => void): EmployeeUpdateAction => ({
  type: actionTypes.EMPLOYEE_UPDATE,
  payload: { next, employee, employeeId }
})

// Success
export interface EmployeeUpdateSuccessAction extends Action {
  payload: {
    employee: Employee
  }
}

export const updateEmployeeSuccess = (employee: Employee): EmployeeUpdateSuccessAction => ({
  type: actionTypes.EMPLOYEE_UPDATE_SUCCESS,
  payload: { employee }
})

// Error
export interface EmployeeUpdateErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const updateEmployeeError = (errorMessage?: string): EmployeeUpdateErrorAction => ({
  type: actionTypes.EMPLOYEE_UPDATE_FAILED,
  payload: { errorMessage }
})

/**
 * Action Types
 */
export type ActionTypes = EmployeesFetchAction
  | EmployeesFetchSuccessAction
  | EmployeesSetCurrentAction
  | EmployeesSetCurrentSuccessAction
  | EmployeesSetCurrentErrorAction
  | EmployeeFetchAction
  | EmployeeFetchSuccessAction
  | EmployeeFetchErrorAction
  | EmployeeFetchFilesSuccessAction
  | EmployeeFetchFilesErrorAction
  | EmployeeFetchCommentsAction
  | EmployeeFetchCommentsSuccessAction
  | EmployeeFetchCommentsErrorAction
  | EmployeeUpdateAction
  | EmployeeUpdateSuccessAction
  | EmployeeUpdateErrorAction



// WEBPACK FOOTER //
// ./src/store/employees/actions.ts